// extracted by mini-css-extract-plugin
export default {"root":"j_RMW8UzfT"};